import script from "./LinkProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkProfile.vue?vue&type=script&setup=true&lang=js"

import "./LinkProfile.vue?vue&type=style&index=0&id=a77a097c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a77a097c"]])

export default __exports__